/**
 * TeamSystem Impact - Reporting Router
 * Gestisce solo la route /reporting/overview (Report DMA)
 */

import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

const ReportingPage = lazy(() =>
  import('./ReportingPage').then((m) => ({ default: m.ReportingPage }))
);

function Loading() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
      <CircularProgress />
    </Box>
  );
}

export function ReportingRouter() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="overview" element={<ReportingPage />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </Suspense>
  );
}
